import { calendari18n } from "./calendari18n";

class FormatDate
{

    constructor(date, timezone = "America/New_York", region = "en-US")
    {

        let count = 0;
        if(typeof date === "string"){
            date = date.split("+")[0];
            date = date.split("T").join(" ");
            date = date + "+00:00"
            if (count === 0) {
                count += 1;
            }

        }

        try {
            timezone = window?.default_timezone ?? timezone;
        } catch (error) {

        }
        const app = this;
        this.is_null_date = false;
        if(date === null){
            this.is_null_date = true;
        }

        let date_object = new Date(new Date(date).toLocaleString(region, {timeZone: timezone}))




/*         if(region !== "en"){
            date_object = new Date(new Date()).toLocaleString(region, {timeZone: timezone});
            console.log(date_object);
        } */


        this.month = date_object.toLocaleString('default', { month: 'long', /*timeZone: timezone*/});

        this.month_date = date_object.getMonth()+1;
        if(`${this.month_date}`.length === 1){
            this.month_date = `0${this.month_date}`
        }

        try {
            this.month = calendari18n().months[date_object.getMonth()];
        } catch (error) {

        }


        this.day = date_object.getDate();
        this.year = date_object.getFullYear();
        this.minutes = null;
        this.hours = null;
        this.only_hours = null;
        this.formatAMPM = (date)=>{
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0'+minutes : minutes;
            minutes = `${minutes}`;
            var strTime = hours + ':' + minutes + ' ' + ampm;

            app.hours = hours;
            app.minutes = minutes;
            app.only_hours = `${hours}`;
            return strTime;
        }

        this.hour = this.formatAMPM(date_object);

    }
    /**
     * @returns format: Diciembre 18, 2022
     */
    month_day_year(){
        if(this.is_null_date){return null;}
        return `${this.month} ${this.day}, ${this.year}`
    }

    /**
     * @returns format: Diciembre 18, 2022 : 4:00 PM
     */
    month_day_year_time(){
        if(this.is_null_date){return null;}
        return `${this.month} ${this.day}, ${this.year} : ${this.hour}`
    }

    /**
     * @returns format: Diciembre 18, 2022 : 4
     */
    month_day_year_only_hours(){
        if(this.is_null_date){return null;}
        return `${this.month} ${this.day}, ${this.year} : ${this.only_hours}:00`
    }

    /**
     * @returns format: 2022-12-28
     */
    system_date(){
        if(isNaN(this.year)){return null;};
        if(isNaN(this.month_date)){return null;};
        if(isNaN(this.day)){return null;};
        if(this.is_null_date){return null;}

        return `${this.year}-${this.month_date}-${this.day}`
    }

    /**
     * @returns format: 2022-12-28
     */
    system_date_hour(){
        if(isNaN(this.year)){return null;};
        if(isNaN(this.month_date)){return null;};
        if(isNaN(this.day)){return null;};
        if(this.is_null_date){return null;}

        let hour = this.hour.split("pm").join("PM");
        hour = hour.split("am").join("AM");


        return `${this.year}-${this.month_date}-${this.day} ${hour}`;
    }

    /**
     * @returns format: 18 de Diciembre de 2022
    */
    full_day_month_year(division){
        division = division || " de";
        if(window?.language !== "es"){
            return `${this.month} ${this.day}, ${this.year}`
        }
        if(this.is_null_date){return null;}
        return `${this.month} ${this.day}, ${this.year}`
    }

    /**
     * @returns format: 18 de Diciembre
    */
    full_day_month(division){
        division = division || " de";
        try {
            if(window?.language !== "es"){
                return `${this.month} ${this.day}, ${this.year}`
            }
        } catch (error) {

        }
        if(this.is_null_date){return null;}
        return `${this.month} ${this.day}`
    }

        /**
     * @returns format: 18 de Diciembre de 2022
    */
    full_day_month_year_time(division, set_time = false){
        division = division || " de";
        try {
            if(window?.language !== "es"){
                return `${this.month} ${this.day}, ${this.year}`
            }
        } catch (error) {

        }

        let full_time = this.hour.split("pm").join("PM");
        full_time = full_time.split("am").join("AM");
        if(set_time === true){
            `${this.hour} : ${this.minutes}`
        }

        if(this.is_null_date){return null;}
        return `${this.month} ${this.day}, ${this.year} ${full_time}`
    }

    /**
     *
     * @returns  6:00pm
     */
    get_only_hours(){
        return `${this.hour}`
    }

    convertUTCToLocal(utcTimestamp) {
        // Parse the UTC timestamp
        const utcDate = new Date(utcTimestamp);

        // Get the timezone offset in milliseconds
        const offset = utcDate.getTimezoneOffset() * 60000;

        // Adjust the UTC date for local time
        const localDate = new Date(utcDate.getTime() + offset);

        // Format the date as desired
        const formattedDate = localDate.toLocaleDateString(); // Or use Intl.DateTimeFormat for more customization

        return formattedDate;
      }

    getStartOfDay(system_date){
        system_date = system_date.split("T")[0];
        return new Date(`${system_date} 00:00:00`);
    }

    getEndOfDay(system_date){
        system_date = system_date.split("T")[0];
        return new Date(`${system_date} 23:59:59`);
    }
}

export {FormatDate}
